export const proposalInProgress = [
  'id',
  'status',
  'data_solicitacao',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'contrato__status',
  'contrato__ccb_original_pdf',
  'contrato__protocolo_digital_pdf',
  'pagamento__banco_nome',
  'pagamento__agencia',
  'pagamento__agencia_dac',
  'pagamento__conta',
  'pagamento__conta_dac',
  'contrato__localizador',
  'contrato__status',
  'convenio__validacao_documentos',
]

export const proposalViewQuery = [
  'funcionario',
  'empresa',
  'contrato',
  'id',
  'localizador',
  'financeira',
  'status',
  'data_primeiro_vencimento',
  'ultimo_vencimento',
  'data_solicitacao',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'modalidade',
  'pagamento',
]

export const contractProposalViewQuery = [
  'status',
  'data_solicitacao',
  'valor_solicitado',
  'valor_liberado',
  'valor_financiado',
  'valor_seguro',
  'valor_juros',
  'valor_iof',
  'taxa_iof',
  'taxa_contrato',
  'taxa_cet_mes',
  'valor_tarifas',
  'prazo',
  'contrato__data_primeiro_vencimento',
  'contrato__data_ultimo_vencimento',
  'contrato__saldo_devedor',
  'contrato__status_averbacao',
  'contrato__status',
  'contrato__ccb_original_pdf',
  'contrato__protocolo_digital_pdf',
  'contrato__ccb_original_html',
  'contrato__valor_parcela',
]

export const proposalCTViewQuery = [
  'status',
  'data_solicitacao',
  'valor_solicitado',
  'valor_liberado',
  'valor_financiado',
  'valor_seguro',
  'valor_juros',
  'valor_iof',
  'taxa_iof',
  'taxa_contrato',
  'taxa_cet_mes',
  'valor_tarifas',
  'prazo',
  'valor_recebivel',
  'data_primeiro_vencimento',
  'ultimo_vencimento',
  'contrato__status_averbacao',
  'contrato__status',
  'contrato__ccb_original_pdf',
  'contrato__protocolo_digital_pdf',
  'contrato__ccb_original_html',
  'contrato__valor_parcela',
]

export const proposalCardQuery = [
  'id',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'ultimo_vencimento',
  'data_solicitacao',
  'contrato__id',
  'contrato__ultimo_vencimento',
  'contrato__gerado_em',
  'status',
  'localizador',
]

export const proposalDashboardQuery = [
  'id',
  'prazo',
  'valor_recebivel',
  'valor_solicitado',
  'valor_parcela',
  'status',
  'contrato__ccb_original_pdf',
  'contrato__protocolo_digital_pdf',
  'contrato__ccb_original_html',
  'contrato__status',
  'contrato__status_averbacao',
  'data_solicitacao',
  'origem',
  'financeira',
  'migrado_em',
  'localizador',
  'convenio',
]

export const proposalListQuery = [
  'id',
  'nome',
  'sobrenome',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'status',
  'cpf',
  'cnpj',
  'empresa__cnpj',
  'nome_fantasia',
  'localizador',
  'documentacao_comprovacao',
  'data_solicitacao',
  'modalidade',
  'alienacao',
  'pagamento',
  'agente_certificado',
  'descricao_bem_servico',
]

export const proposalViewQueryCorban = [
  'id',
  'localizador',
  'status',
  'valor_liberado',
  'nome',
  'sobrenome',
  'cpf',
  'modalidade',
  'origem',
  'data_solicitacao',
  'data_nascimento',
  'nacionalidade',
  'sexo',
  'estado_civil',
  'telefone_celular',
  'nome_mae',
  'cliente_info_no_contrato__documento__numero',
  'cliente_info_no_contrato__cpf',
  'cliente_info_no_contrato__documento__emissor',
  'cliente_info_no_contrato__documento__uf',
  'cliente_info_no_contrato__documento__data_emissao',
  'cliente_info_no_contrato__cargo',
  'cliente_info_no_contrato__endereco__cep',
  'cliente_info_no_contrato__endereco__cidade',
  'cliente_info_no_contrato__endereco__bairro',
  'cliente_info_no_contrato__endereco__logradouro',
  'cliente_info_no_contrato__endereco__numero',
  'cliente_info_no_contrato__endereco__complemento',
  'cliente_info_no_contrato__endereco__uf',
  'cliente_info_no_contrato__pagamento__banco',
  'cliente_info_no_contrato__pagamento__agencia',
  'cliente_info_no_contrato__pagamento__agencia_dac',
  'cliente_info_no_contrato__pagamento__conta',
  'cliente_info_no_contrato__pagamento__conta_dac',
  'cliente_info_no_contrato__salario_bruto',
  'documentacao_comprovacao',
  'telefone_fixo',
  'email',
  'empresa__razao_social',
  'empresa__cnpj',
  'empresa__endereco__cep',
  'empresa__endereco__uf',
  'empresa__endereco__cidade',
  'empresa__endereco__bairro',
  'empresa__endereco__logradouro',
  'empresa__endereco__numero',
  'empresa__endereco__complemento',
  'valor_financiado',
  'valor_liberado',
  'valor_recebivel',
  'data_primeiro_vencimento',
  'data_ultimo_vencimento',
  'prazo',
  'taxa_contrato',
  'data_solicitacao',
  'valor_iof',
  'taxa_iof',
  'valor_seguro',
  'valor_tarifas',
  'ultimo_vencimento',
]

export const cdcProposalMetadata = ['metadados']

export const cpProposalSendDocuments = [
  'id',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'cpf',
  'documentacao_comprovacao',
]

export const corbanCEPProposal = [
  'status',
  'convenio',
  'empresa__nome_fantasia',
  'origem',
  'cliente_info_no_contrato__nome',
  'cliente_info_no_contrato__sobrenome',
  'cliente_info_no_contrato__cpf',
  'cliente_info_no_contrato__email',
  'cliente_info_no_contrato__pagamento',
  'funcionario__nome',
  'funcionario__sobrenome',
  'funcionario__cpf',
  'data_solicitacao',
  'data_primeiro_vencimento',
  'data_ultimo_vencimento',
  'telefone_celular',
  'financeira_valor_a_pagar',
  'prazo',
  'valor_financiado',
  'valor_parcela',
  'email',
  'id',
  'autorizador_msg',
  'valor_solicitado',
  'valor_recebivel',
  'localizador',
]

export const corbanCEPProposalCSV = [
  'status',
  'empresa__nome_fantasia',
  'id',
  'pagamento__banco',
  'pagamento__agencia',
  'pagamento__agencia_dac',
  'pagamento__conta',
  'pagamento__conta_dac',
  'origem',
  'funcionario__nome',
  'funcionario__sobrenome',
  'funcionario__cpf',
  'telefone_celular',
  'email',
  'data_solicitacao',
  'data_primeiro_vencimento',
  'ultimo_vencimento',
  'valor_financiado',
  'prazo',
  'valor_recebivel',
  'autorizador_msg',
]

export const pjProposalListQuery = [
  'id',
  'cliente_info_no_contrato',
  'origem',
  'status',
  'localizador',
  'data_solicitacao',
  'valor_solicitado',
  'valor_recebivel',
  'prazo',
  'cnpj',
  'nome_fantasia',
  'pagamento__banco',
  'pagamento__agencia',
  'pagamento__agencia_dac',
  'pagamento__conta',
  'pagamento__conta_dac',
  'pagamento__tipo_chave_pix',
  'pagamento__chave_pix',
]

export const corbanCTProposal = [
  'status',
  'convenio',
  'empresa__nome_fantasia',
  'origem',
  'cliente_info_no_contrato__nome',
  'cliente_info_no_contrato__sobrenome',
  'cliente_info_no_contrato__cpf',
  'cliente_info_no_contrato__email',
  'cliente_info_no_contrato__pagamento',
  'funcionario__nome',
  'funcionario__sobrenome',
  'funcionario__cpf',
  'data_solicitacao',
  'data_primeiro_vencimento',
  'data_ultimo_vencimento',
  'telefone_celular',
  'financeira_valor_a_pagar',
  'prazo',
  'valor_financiado',
  'valor_parcela',
  'email',
  'id',
  'autorizador_msg',
  'valor_solicitado',
  'valor_recebivel',
  'localizador',
  'nome',
  'sobrenome',
  'cpf',
  'ultimo_vencimento',
]
